// Da Vinci Institute - Department Content Data
// All content in 3 languages: English (en), Arabic (ar), Kurdish (ku)

import aliAhmed from '../assets/images/staff/ali-ahmed.jpg';
import hendrinMohammed from '../assets/images/staff/hendrin-mohammed.jpg';
import diyarAbdulsalam from '../assets/images/staff/diyar-abdulsalam.jpg';

export const departments = {
  computerScience: {
    id: 'computer-science',
    slug: 'computer-science',
    icon: '💻',
    established: '2012-2013',
    department_email: 'Cmp.Dept@dvinst.com',
    en: {
      title: 'Computer Science Department',
      shortTitle: 'Computer Science',
      description: 'The Department of Computer Science was established in the academic year 2012-2013, coinciding with the founding of the Da Vinci institute. During the first three years, the curriculum provides a general foundation in Computer Science. In the fourth and fifth years, students may choose to specialize in one of the following areas: Network, Programming, or Web Development. Upon successful completion of all five stages, graduates will be awarded a Diploma in Computer Science by the Ministry of Education.',
      objectives: 'Computers are integral to modern society, and computer science is widely regarded as one of the fundamental disciplines worldwide. At this department, we are committed to providing our students with a comprehensive education in all areas of their field, ensuring they remain abreast of the latest developments in the world of computing. Our aim at Davinci Institute is to equip students with both theoretical knowledge and practical skills, preparing them to excel in their future careers—whether in the private or public sectors, or through continued academic pursuits at the university level.',
    },
    ar: {
      title: 'قسم علوم الحاسبات',
      shortTitle: 'علوم الحاسبات',
      description: 'تم تأسيس قسم علوم الحاسوب في العام الدراسي (2012-2013)، بالتزامن مع تأسيس المؤسسة. يقدم البرنامج منهجاً دراسياً واسع النطاق خلال السنوات الثلاث الأولى. وفي السنتين الرابعة والخامسة، يُتاح للطلاب خيار التخصص في أحد المجالات التالية: الشبكات، البرمجة، أو تصمیم الويب وعند إتمام البرنامج الذي يستغرق خمس سنوات بنجاح، يمنح الخريجون شهادة الدبلوم في علوم الحاسوب من قبل وزارة التربية.',
      objectives: 'تعد أجهزة الحاسوب جزءاً لا يتجزأ من المجتمع الحديث، ويُعتبر تخصص علوم الحاسوب على نطاق واسع واحداً من التخصصات الأساسية في جميع أنحاء العالم. في هذا القسم، نحن ملتزمون بتزويد طلابنا بتعليم شامل في جميع مجالات تخصصهم، مما يضمن بقاءهم على اطلاع دائم بأحدث التطورات في عالم الحوسبة. إن هدفنا في معهد داڤنشي هو تسليح الطلاب بالمعرفة النظرية والمهارات العملية، وإعدادهم للتميز في حياتهم المهنية المستقبلية—سواء في القطاع الخاص أو العام، أو من خلال مواصلة تحصيلهم الأكاديمي في المرحلة الجامعية.',
    },
    ku: {
      title: 'بەشێ زانستێن کۆمپیوتەری',
      shortTitle: 'زانستێن کۆمپیوتەری',
      description: 'بەشێ زانستێن کۆمپیۆتەرێ ل سالا خواندنێ (٢٠١٢-٢٠١٣) هاتە دامەزراندن، کو هەڤدەم بوو دگەل دامەزراندنا پەیمانگەها داڤنشی ب خۆ . ئەڤ پرۆگرامە د سێ سالێن دەستپێکێ دا پڕۆگرامەکێ خواندنێ یێ بەرفرهـ پێشکێش دکەت . پشتی ب دووماهی ئینانا پرۆگرامی ب سەرکەفتیانە د ماوێ پێنج سالان دا، دێ بروانامەیا دیپلۆمێ د زانستێن کۆمپیۆتەرێ دا ژ لایێ وەزارەتا پەروەردێ ڤە ب دەرچوویان هێتە بەخشین .',
      objectives: 'کۆمپیۆتەر پشکەکا سەرەکییە ژ جڤاکێ سەردەم، و زانستێن کۆمپیۆتەری ل سەرانسەری جیهانێ وەک ئێک ژ دیسپلینێن بنەڕەتی دهێنە هەژمارتن. ل ڤێ پشکێ، ئەم پێگیرین ب دابینکرنا پەروەردەکا گشتگیر بۆ قوتابیێن خۆ د هەمی بوارێن پسپۆرییا وان دا. ئارمانجا مە ل پەیمانگەها داڤنشی ئەوە کو قوتابی ب زانینێن تیۆری و شارەزاییێن پراکتیکی بەرهەڤ بکەین، دا کو بەرهەڤ بن بۆ سەرکەفتنێ د کارێن خۆ یێن پاشەرۆژێ دا—چ د کەرتێ تایبەت دا بن یان یێ گشتی.',
    },
    coordinator: {
      name: 'Ali Ahmed Abu-Baker',
      email: 'ali.ahmed@dvinst.com',
      phone: '+964 750 181 11 41',
      image: aliAhmed
    }
  },
  oilGas: {
    id: 'oil-gas',
    slug: 'oil-gas',
    icon: '⚙️',
    established: '2014-2015',
    department_email: 'Pet.Dept@dvinst.com',
    en: {
      title: 'Oil & Gas Sciences Department',
      shortTitle: 'Oil & Gas Sciences',
      description: 'The Department of Oil and Gas Sciences was established in the academic year 2014–2015, making Da Vinci Institute the first institute in the Kurdistan Region to offer this specialization. The department provides students with essential academic and practical training in oil refining and petroleum sciences. Graduates who complete all five academic stages are awarded a Diploma in Gas and Oil Sciences.',
      objectives: 'Gas and oil are vital national resources and a primary source of economic development in the modern era. The Department of Gas and Oil Sciences is committed to developing scientifically competent and academically qualified professionals for this sector. Through these academic and practical initiatives, the department aims to equip students with the knowledge, skills, and resources necessary to succeed and excel in their professional careers.',
    },
    ar: {
      title: 'قسم علوم النفط والغاز',
      shortTitle: 'علوم النفط والغاز',
      description: 'تأسس قسم علوم النفط والغاز في العام الدراسي ٢٠١٤–٢٠١٥. وكان معهد دا فينشي أول معهد في إقليم كوردستان يستحدث قسماً متخصصاً في علوم النفط والغاز. يزود القسم الطلبة بمعرفة أكاديمية وعملية شاملة في تكرير النفط، بالإضافة إلى المبادئ العلمية الأساسية المتعلقة بإنتاج النفط ومعالجته.',
      objectives: 'يعد النفط والغاز من الموارد الوطنية الحيوية ومصدراً أساسياً للتنمية الاقتصادية في العصر الحديث. وإدراكاً لأهميتهما الاستراتيجية، يلتزم قسم علوم النفط والغاز بإعداد كوادر مهنية مؤهلة أكاديمياً وكفوءة علمياً لهذا القطاع.',
    },
    ku: {
      title: 'بەشێ زانستێن نەفت و گاز',
      shortTitle: 'زانستێن نەفت و گاز',
      description: 'پشکا زانستێن نەفت و گازی د سالا خاندنێ (٢٠١٤-٢٠١٥) دا هاتە دانان. پەیمانگەها داڤنشی ئێکەم پەیمانگەهـ بوو ل سەر ئاستێ هەرێما کوردستانێ کو پشکەکا تایبەت ب زانستێن نەفت و گازی ڤەبکەت. پشتی ب دوماهی ئینانا هەر پێنج قۆناغێن خاندنێ ب سەرکەفتی، بڕواناما دبلۆم د زانستێن نەفت و گازی دا ددەنە دەرچوویان.',
      objectives: 'نەفت و گاز ژێدەرێن نەتەوەیی یێن زێدە گرنگن و ئەگەرێ سەرەکی یێ گەشەیا ئابووری نە د چەرخێ نوکە دا. ئارمانج ئەوە کو قوتابیان ب زانیاری و کارامەیی و شارەزایێن پێدویست چەکدار بکەت دا کو د ژیانا خۆ یا پیشەیی دا سەرکەفتی بن.',
    },
    coordinator: {
      name: 'Hindreen Saleem',
      email: 'Hindreen.Saleem@dvinst.com',
      phone: '+964 750 181 11 51',
      image: hendrinMohammed
    }
  },
  management: {
    id: 'management',
    slug: 'management',
    icon: '📊',
    established: '2012-2026',
    department_email: 'Mng.Dept@dvinst.com',
    en: {
      title: 'Management Department',
      description: 'The Department of Management offers a comprehensive academic program designed to equip students with essential managerial, administrative, and organizational skills. Upon successful completion of the five academic stages, graduates are awarded a Diploma in Management.',
      objectives: 'The Department of Management aims to prepare competent and skilled professionals capable of effectively managing organizations in both the public and private sectors. Focusing on developing students\' leadership, analytical, and decision-making abilities.',
    },
    ar: {
      title: 'قسم الإدارة',
      description: 'تأسس قسم الإدارة في العام الدراسي ٢٠٢٠–٢٠٢١. يقدم القسم برنامجاً أكاديمياً شاملاً صُمم لإكساب الطلبة المهارات القيادية والإدارية والتنظيمية الأساسية. وبعد اجتياز المراحل الدراسية الخمس بنجاح، يمنح الخريجون شهادة الدبلوم في الإدارة.',
      objectives: 'يهدف قسم الإدارة إلى إعداد كوادر مهنية كفوءة وماهرة قادرة على إدارة المؤسسات بفعالية في القطاعين العام والخاص.',
    },
    ku: {
      title: 'پشکا کارگێڕی',
      description: 'پشکا کارگێڕی ل پەیمانگەها داڤنشی د سالا خاندنێ (٢٠٢٠-٢٠٢١) دا هاتە ڤەکرن. ئەڤ پشکە پڕۆگرامەکێ زانستی یێ تێروتەسەل پێشکێش دکەت کو هاتیە دارێژتن دا کو قوتابیان ب کارامەییێن سەرەکی یێن بڕێڤەبرنێ چەکدار بکەت.',
      objectives: 'ئارمانجا پشکا کارگێڕیێ ئەوە کو کەسێن خودان شیان و شارەزا بەرهەڤ بکەت، دا کو بشێن ب شێوەیەکێ سەرکەفتی رێڤەبەریا دامودەزگەهان بکەن.',
    },
    coordinator: {
      name: 'Diyar Abdulsalam',
      email: 'Diyar.abdulsalam@dvinst.com',
      phone: '+964 750 181 11 31',
      image: diyarAbdulsalam
    }
  },
  accounting: {
    id: 'accounting',
    slug: 'accounting',
    icon: '📈',
    established: '2012-2026',
    department_email: 'Acc.Dept@dvinst.com',
    en: {
      title: 'Accounting Department',
      description: 'The Department of Accounting offers a structured academic program designed to provide students with a strong foundation in accounting principles, financial reporting, and business practices. Upon successful completion of the five academic stages, graduates are awarded a Diploma in Accounting.',
      objectives: 'The Department of Accounting aims to prepare qualified and competent professionals capable of meeting the financial and accounting needs of modern organizations. Focusing on developing students\' analytical, numerical, and problem-solving skills.',
    },
    ar: {
      title: 'قسم المحاسبة',
      description: 'تأسس قسم المحاسبة في العام الدراسي ٢٠٢٠–٢٠٢١. يقدم القسم برنامجاً أكاديمياً منظماً صُمم لتزويد الطلبة بأساس قوي في مبادئ المحاسبة، والتقارير المالية، والممارسات التجارية.',
      objectives: 'يهدف قسم المحاسبة إلى إعداد كوادر مهنية مؤهلة وكفوءة قادرة على تلبية الاحتياجات المالية والمحاسبية للمؤسسات الحديثة.',
    },
    ku: {
      title: 'پشکا ژمێریاری',
      description: 'پشکا ژمێریاری ل پەیمانگەها داڤنشی د سالا خاندنێ (٢٠٢٠-٢٠٢١) دا هاتە ڤەکرن. ئەڤ پشکە پڕۆگرامەکێ زانستی یێ رێکوپێک پێشکێش دکەت کو هاتیە دارێژتن دا کو بنەمایەکێ ب هێز د بنەمایێن ژمێریاری دا بدەتە قوتابیان.',
      objectives: 'ئارمانجا پشکا ژمێریاریێ ئەوە کو کەسێن خودان شیان و بسپۆر بەرهەڤ بکەت، دا کو بشێن پێدویستیێن دارایی و ژمێریاری یێن سازیێن ئەڤڕۆ دابین بکەن.',
    },
    coordinator: {
      name: 'Diyar Abdulsalam',
      email: 'Diyar.abdulsalam@dvinst.com',
      phone: '+964 750 181 11 31',
      image: diyarAbdulsalam
    }
  }
};

export const getAllDepartments = () => Object.values(departments);
export const getDepartmentBySlug = (slug) => Object.values(departments).find(d => d.slug === slug);
